export const toGeneratedId = (value = 1) => Math.floor(Math.random() * 1000000) + value;
